import React, { useContext, useMemo } from 'react';
import { useHits, useCurrentRefinements, Highlight } from 'react-instantsearch-hooks-web';
import { useZipCodeStatus } from '../../hooks/app';
import { groupProductByCategroies } from '../../helpers/search';
import IndividualCategory from '../DTC/grassdoor/IndividualCategory';
import appContext from '../../Context/appContext';
import { useSelector } from 'react-redux';

const SearchCategories = ({ currentTab, bringItProducts, hideSlider, isSearchPage, isSearchedProducts, setSimlarProductsLoading, fullCategoryList }) => {

  // const {
  //   state: {
  //     search: {
  //       searchQuery,
  //       selectedPriceSort
  //     }
  //   }
  // } = useContext(appContext)

  const { searchQuery, selectedPriceSort } = useSelector(state => state.search)

  const {
    data: { locationId, zoneId }
  } = useZipCodeStatus();

  const { items: categoryRefinment } = useCurrentRefinements({
    includedAttributes: ['full_shop_categories']
  });

  const { hits } = useHits({});

  const categories = useMemo(() => {
    return groupProductByCategroies({ hits, categoryRefinment, locationId, zoneId, currentTab, searchQuery, selectedPriceSort, bringItProducts, fullCategoryList })
  }, [locationId, hits, categoryRefinment, currentTab, searchQuery, selectedPriceSort, bringItProducts]);

  return (
    categories?.length
      ? categories.map(cat => (
        <div className="mb-5" key={cat?.category_name}>
          <div className="search-tab-title mb-1">
            <span>{cat?.category_name}</span>
            {/* <Highlight attribute='category_name' hit={cat} />*/}
            {` (${cat?.products?.length})`}
          </div>
          <div className='search-product'>
            <IndividualCategory
              data={cat}
              isSearchPage={isSearchPage}
              hideSlider={hideSlider}
              isSearchedProducts={isSearchedProducts}
              setSimlarProductsLoading={setSimlarProductsLoading}
            />
          </div>
        </div>
      ))
      : null
  )
}

export default SearchCategories